module.exports = __webpack_public_path__ + "media/images/tenor_logo-6b8f81f3.svg";